module.exports = __webpack_public_path__ + "static/media/devflix.2c211ae1.png";